export const ratePlansTab = {
  sectionLabel: {
    title: "الأسعار الظاهرة في الحجز المباشر",
    hintHotel:
      "اختر الأسعار التي تظهر لكل نوع غرفة، وترتيبها، والسعر الافتراضي.",
    hintApartment:
      "اختر الأسعار التي يراها الضيف، واسحبها لإعادة الترتيب، وحدّد السعر الافتراضي.",
  },
  loading: "جارٍ تحميل الأسعار…",
  empty: {
    apartment: "لا توجد أسعار مُعدّة لهذا العقار.",
    hotel: "لا توجد أنواع غرف مُعدّة لهذا الفندق.",
    room: "لا توجد أسعار مُعدّة لهذه الغرفة.",
  },
  derivedPill: "مشتق",
  dragHandleTitle: "اسحب لإعادة الترتيب",
  visibleSwitchTitle: "إظهار في الحجز المباشر",
  expandTitleClose: "إغلاق الإعدادات",
  expandTitleOpen: "ضبط الاسم والسياسة والافتراضي",
  visibleNameLabel: "الاسم الظاهر",
  visibleNamePlaceholderApartment: "مثال: غير قابل للاسترداد / مرن",
  visibleNamePlaceholderHotel: "مثال: يشمل الإفطار",
  cond: {
    refundable: "يمكن الإلغاء",
    refundableHint: "أنت تحدد حتى متى يكون الإلغاء مجانيًا.",
    nonRefundable: "غير قابلة للاسترداد",
    nonRefundableHint: "لا يُسترد أي مبلغ. يمكن للضيف الإلغاء، لكن تُحتسب عليه النسبة كاملة 100٪. يرى ذلك قبل الدفع.",
    freeDays: "إلغاء مجاني حتى",
    freeDaysPlaceholder: "بدون حد",
    freeDaysHelp: "أيام قبل الوصول. فارغ = مجاني حتى الوصول.",
    penalty: "بعد ذلك تتقاضى",
    penaltyHelp: "من إجمالي الإقامة. 100% = لا يُسترد شيء.",
    sinGuardar: "هذه التسعيرة ليس لها شروط محفوظة بعد. ما يظهر أدناه اقتراح — اضغط «حفظ السياسة» لتطبيقه.",
    aplicarTodas: "تطبيق على كل الغرف",
    aplicarTodasHelp: "سيُطبَّق نفس الشرط على تسعيرة «{name}» في غرفة واحدة أخرى. | سيُطبَّق نفس الشرط على تسعيرة «{name}» في {count} غرف أخرى.",
    notes: "ملاحظات للضيف (اختياري)",
    previewNonRefundable: "سيقرأ الضيف: «هذه التعرفة غير قابلة للاسترداد: لا يمكن إلغاء الحجز».",
    previewFree: "سيقرأ الضيف: «إلغاء مجاني حتى الوصول».",
    previewDayPenalty: "سيقرأ الضيف: «إلغاء مجاني حتى يوم الوصول؛ بعد ذلك تُحتسب {pct}%».",
    previewUntilPenalty: "سيقرأ الضيف: «مجاني حتى يوم واحد قبل؛ بعد ذلك تُحتسب {pct}%». | سيقرأ الضيف: «مجاني حتى {count} أيام قبل؛ بعد ذلك تُحتسب {pct}%».",
    shortNonRefundable: "غير قابلة للاسترداد",
    shortFree: "إلغاء مجاني",
    shortDayPenalty: "مجاني حتى الوصول · ثم {pct}%",
    shortUntilPenalty: "مجاني حتى يوم واحد قبل · ثم {pct}% | مجاني حتى {count} أيام قبل · ثم {pct}%",
  },
  cancellationPolicyLabel: "سياسة الإلغاء",
  policyEmpty: "لم تُحدَّد سياسة",
  policyEdit: "تعديل",
  policyAdd: "إضافة",
  defaultLabel: "افتراضي",
  rulesApartment: "القواعد: سعر ظاهر واحد على الأقل وسعر افتراضي واحد (يجب أن يكون ظاهرًا).",
  rulesRoom: "يجب أن تحتوي كل غرفة على سعر ظاهر واحد على الأقل وسعر افتراضي واحد.",
  tip: 'نصيحة: اجعل سعرًا "مرنًا" افتراضيًا واعرض غيره كـ"غير قابل للاسترداد".',
  room: {
    ratePlansCount: "{count} سعر | {count} أسعار",
    includedGuestsTitle:
      "عدد الضيوف الذين يشملهم السعر (لاحتساب رسوم الضيف الإضافي)",
    includes: "يشمل",
    person: "ضيف | ضيوف",
    meta: "السعة: {capacity} • البالغون: {adults} • الأطفال: {children}",
  },
  modal: {
    eyebrow: "سياسة الإلغاء",
    closeAria: "إغلاق",
    hint: "سيظهر هذا النص للضيف في الحجز المباشر. صِف شروط الإلغاء الخاصة بهذا السعر.",
    textareaPlaceholder:
      "مثال: إلغاء مجاني حتى 48 ساعة قبل تسجيل الوصول. بعد ذلك، تُحتسب الليلة الأولى. غير قابل للاسترداد في الموسم المرتفع.",
    clear: "مسح",
    cancel: "إلغاء",
    saving: "جارٍ الحفظ…",
    save: "حفظ السياسة",
    defaultTitle: "سعر",
  },
  toasts: {
    loadError: "تعذّر تحميل الأسعار.",
    saveSuccess: "تم حفظ الأسعار بنجاح.",
    saveError: "تعذّر حفظ الأسعار.",
  },
  validation: {
    roomMinVisible: 'يجب أن تحتوي الغرفة "{name}" على سعر ظاهر واحد على الأقل.',
    roomOneDefault: 'يجب أن تحتوي الغرفة "{name}" على سعر افتراضي واحد بالضبط.',
    roomDefaultVisible: 'في "{name}"، يجب أن يكون السعر الافتراضي ظاهرًا.',
    minVisible: "يجب أن تُبقي سعرًا ظاهرًا واحدًا على الأقل.",
    oneDefault: "يجب أن يوجد سعر افتراضي واحد بالضبط.",
    defaultVisible: "يجب أن يكون السعر الافتراضي ظاهرًا.",
  },
};
